import type { AnyPostgrestResponse } from '@supabase-cache-helpers/postgrest-core';
import { buildQueryOpts } from '@supabase-cache-helpers/postgrest-react-query';
import type { PostgrestError } from '@supabase/postgrest-js';
import type { FetchQueryOptions, QueryClient } from '@tanstack/react-query';

export async function ensureQueryData<Result>(
  queryClient: QueryClient,
  query: PromiseLike<AnyPostgrestResponse<Result>>,
  config?: Omit<
    FetchQueryOptions<AnyPostgrestResponse<Result>, PostgrestError>,
    'queryKey' | 'queryFn'
  >,
) {
  await queryClient.ensureQueryData<
    AnyPostgrestResponse<Result>,
    PostgrestError
  >(buildQueryOpts(query, config));
}
